import { apiCall } from "api-calls/api-call"

export type IRedeemLimits = {
  maxUsdForRedeemDailyGlobal: number
  maxUsdForRedeemDailyPerUser: number
  utcHoursForMarketplaceRedemptionLimitReset: number
  numberOfUsersDailyRedemptionAttempts: number

  /** Read-only computed fields returned by the API (points equivalent = USD * 1000) */
  maxPointsForRedeemDailyGlobal?: number
  maxPointsForRedeemDailyPerUser?: number
}

type UpdateRedeemLimitsInput = Omit<IRedeemLimits, "maxPointsForRedeemDailyGlobal" | "maxPointsForRedeemDailyPerUser">

export const getRedeemLimits = async(): Promise<IRedeemLimits> => {
  return apiCall({
    method: "GET",
    path: "buff-play/marketplace/settings",
  })
}

export const updateRedeemLimits = async({
  maxPointsForRedeemDailyGlobal: _global,
  maxPointsForRedeemDailyPerUser: _perUser,
  ...input
}: IRedeemLimits): Promise<IRedeemLimits> => {
  return apiCall({
    method: "PUT",
    path: "buff-play/marketplace/settings",
    body: input satisfies UpdateRedeemLimitsInput,
  })
}
